import { render, staticRenderFns } from "./DigitalAnalyticsReportStatsDashboard.vue?vue&type=template&id=4508d1ac&"
import script from "./DigitalAnalyticsReportStatsDashboard.vue?vue&type=script&lang=js&"
export * from "./DigitalAnalyticsReportStatsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports